import { render, staticRenderFns } from "./EnergyData.vue?vue&type=template&id=2f6d3f7a&scoped=true&"
import script from "./EnergyData.vue?vue&type=script&lang=js&"
export * from "./EnergyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d3f7a",
  null
  
)

export default component.exports